import { render, staticRenderFns } from "./ShootingChart.vue?vue&type=template&id=63f9b2ba&scoped=true&"
import script from "./ShootingChart.vue?vue&type=script&lang=js&"
export * from "./ShootingChart.vue?vue&type=script&lang=js&"
import style0 from "./ShootingChart.vue?vue&type=style&index=0&id=63f9b2ba&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f9b2ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
